var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editProfileContainer"}},[_c('profile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }